import log from 'loglevel'
import axios from 'axios'

/* eslint class-methods-use-this: ["off"] */

export default class OrderProduct {
  constructor() {
    log.info('[INFO] Initialize Order Product Module')
  }

  getProductReport(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`v1/order/products/${id}/`)
        .then(response => {
          log.debug('[DEBUG] Success to get order product report')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to get order product report')
          log.error(error)
          reject(error.response)
        })
    })
  }
}
